import { render, staticRenderFns } from "./WarehouseSelector.vue?vue&type=template&id=61bb4ba0&scoped=true&"
import script from "./WarehouseSelector.vue?vue&type=script&lang=js&"
export * from "./WarehouseSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bb4ba0",
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormSelectOption, BFormSelect} from 'bootstrap-vue'
    installComponents(component, {BFormSelectOption, BFormSelect})
    

export default component.exports